import { gql } from '@apollo/client';

export const ALL_CREDENTIALS = gql`
  query AllCredentials($userId: Int, $extended: Boolean!, $credentialsAdmin: Boolean = false) {
    credentials(
      credentialTableInput: { filterQuery: {}, sortBy: updatedAt, sortDirection: desc }
      userId: $userId
    ) {
      edges {
        id
        name
        source
        address
        startDate
        endDate
        years @include(if: $extended)
        filterSpam
        credentialType
        integrationId
        isOauth
        integrationName @include(if: $extended)
        accountId
        account {
          id
          name
          integrationId
        }
        status @include(if: $extended)
        createdAt @include(if: $extended)
        updatedAt @include(if: $extended)
        earliestTransaction @include(if: $extended)
        latestTransaction @include(if: $extended)
        txnCount @include(if: $extended)
        uploads @include(if: $extended) {
          id
          name
          timezone
        }
        lastRefreshError @include(if: $extended)
        errorRemediation @include(if: $extended)
        requiresCredentialUpdate @include(if: $extended)
        credentials @include(if: $credentialsAdmin)
      }
    }
  }
`;
